import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const Register = () => {
  const [formData, setFormData] = useState({
    telegramUsername: '',
    username: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validate passwords
    if (formData.password.length < 6) {
      setError('Şifre en az 6 karakter olmalıdır');
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Şifreler eşleşmiyor');
      setLoading(false);
      return;
    }

    try {
      const { confirmPassword, ...dataToSend } = formData;
      const response = await axios.post('/api/auth/register', dataToSend);

      // Store user token
      localStorage.setItem('userToken', response.data.token);
      localStorage.setItem('userData', JSON.stringify(response.data.user));
      
      // Custom event for layout update
      window.dispatchEvent(new Event('userTokenChanged'));
      
      // Show success message
      if (response.data.message) {
        alert(response.data.message);
      }
      
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Kayıt başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-dark px-4">
      <div className="bg-gradient-card p-8 rounded-xl shadow-card border-2 border-gold/30 w-full max-w-md">
        <h1 className="text-3xl font-bold text-center text-gold mb-8">
          Üye Ol
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="bg-red-500/10 border border-red-500 text-red-500 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

          <div>
            <label className="block text-white mb-2 font-medium">
              Telegram Kullanıcı Adı <span className="text-gold">*</span>
            </label>
            <input
              type="text"
              name="telegramUsername"
              value={formData.telegramUsername}
              onChange={handleChange}
              placeholder="@kullaniciadi"
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
              required
            />
            <p className="text-gray-400 text-sm mt-1">Telegram kullanıcı adınızı giriniz (örn: @kullaniciadi)</p>
          </div>

          <div>
            <label className="block text-white mb-2 font-medium">
              Kullanıcı Adı <span className="text-gold">*</span>
            </label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="kullaniciadi"
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2 font-medium">
              E-posta <span className="text-gold">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="ornek@email.com"
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2 font-medium">
              Şifre <span className="text-gold">*</span>
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="En az 6 karakter"
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
              required
              minLength={6}
            />
            <p className="text-gray-400 text-sm mt-1">Şifre en az 6 karakter olmalıdır</p>
          </div>

          <div>
            <label className="block text-white mb-2 font-medium">
              Şifre Tekrar <span className="text-gold">*</span>
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Şifrenizi tekrar giriniz"
              className="w-full px-4 py-3 bg-navy-700 border border-gold/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-gold transition-colors"
              required
              minLength={6}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Kayıt yapılıyor...' : 'Kayıt Ol'}
          </button>
        </form>

        <div className="mt-6 text-center space-y-2">
          <p className="text-gray-400">
            Zaten hesabınız var mı?{' '}
            <Link to="/login" className="text-gold hover:text-gold-light transition-colors font-medium">
              Giriş Yap
            </Link>
          </p>
          <Link to="/" className="text-gold hover:text-gold-light transition-colors text-sm block">
            ← Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
